import React from 'react';
import PollSuccessLoginBlocker from 'routes/liveblog_v2/components/common/TimelinePoll/PollSuccessLoginBlocker';
import s from 'routes/liveblog_v2/components/common/TimelinePoll/TimelinePoll.scss';

const LoginBlockerWrapper = props => (
  <div
    className={`general_loginblocker ${s.timeline_pollWrapper} ${
      s.PollSuccessLoginBlocker
    }`}
  >
    <PollSuccessLoginBlocker {...props} hidePollMessage />
  </div>
);

export default LoginBlockerWrapper;
